function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

import "antd/es/time-picker/style";
import _TimePicker from "antd/es/time-picker";
var _excluded = ["value", "$sui"],
    _excluded2 = ["rules", "format", "defaultValue", "id", "verifyTriggers", "formatString", "children", "onVerify", "labelId", "onOpenChange", "hideDefaultErrorMsg", "componentStyle", "help"];

var _class, _class2, _temp;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import classnames from 'classnames';
import locale from "antd/es/date-picker/locale/zh_CN";
import { $attrs } from '../sui/bind';
import moment from "moment";
import "moment/locale/zh-cn";
import createFormComponent from '../sui/createFormComponent';
moment.locale("zh-cn");
/**
 * TimePicker时间选择框控件
 */

var SuiTimePicker = createFormComponent(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(SuiTimePicker, _React$Component);

  var _super = _createSuper(SuiTimePicker);

  function SuiTimePicker(props, context) {
    var _this;

    _classCallCheck(this, SuiTimePicker);

    _this = _super.call(this, props);
    _this.defaultValue = undefined;

    _this.changeHandler = function (date, timeString) {
      _this.changeValue(date, timeString);
    };

    _this.openChangeHandler = function (status) {
      console.log("status => ", status);
      _this.attrs.open = status;
      _this.props.onOpenChange && _this.props.onOpenChange(status);
    };

    _this.getRefDOM = function (node) {
      if (node && _this.refDOM !== node) {
        _this.refDOM = node;
      }

      return _this.refDOM;
    };

    _this.getRefInstance = function (node) {
      if (node && _this.refInstance !== node) {
        _this.refInstance = node;
      }

      return _this.refInstance;
    };

    _this.onBlur = function (e) {
      _this.blurHandler(e);
    };

    _this.onFocus = function (e) {
      _this.focusHandler(e);
    };

    var defaultValue = props.defaultValue;
    _this.attrs = $attrs({
      value: defaultValue,
      readOnly: false,
      disabled: false,
      open: false
    });

    _this.attrs.$sui.attach(props, _assertThisInitialized(_this), context);

    _this.verify("init");

    return _this;
  }

  _createClass(SuiTimePicker, [{
    key: "changeValue",
    value: // onChange修改value值
    function changeValue(date, timeString) {
      this.attrs.value = timeString;

      if (this.props.onChange) {
        this.props.onChange.call(this, date, timeString);
      } // this.verify("change");

    }
  }, {
    key: "focus",
    value: function focus() {
      this.getRefInstance().focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.getRefInstance().blur();
    }
  }, {
    key: "doRender",
    value: function doRender() {
      console.log(" === render timepicker === ", this.attrs.value);

      var _this$attrs = this.attrs,
          value = _this$attrs.value,
          $sui = _this$attrs.$sui,
          attrs = _objectWithoutProperties(_this$attrs, _excluded);

      var _$sui$restProps = $sui.restProps,
          rules = _$sui$restProps.rules,
          format = _$sui$restProps.format,
          defaultValue = _$sui$restProps.defaultValue,
          _$sui$restProps$id = _$sui$restProps.id,
          id = _$sui$restProps$id === void 0 ? this.uuid : _$sui$restProps$id,
          verifyTriggers = _$sui$restProps.verifyTriggers,
          formatString = _$sui$restProps.formatString,
          children = _$sui$restProps.children,
          onVerify = _$sui$restProps.onVerify,
          labelId = _$sui$restProps.labelId,
          onOpenChange = _$sui$restProps.onOpenChange,
          hideDefaultErrorMsg = _$sui$restProps.hideDefaultErrorMsg,
          componentStyle = _$sui$restProps.componentStyle,
          help = _$sui$restProps.help,
          props = _objectWithoutProperties(_$sui$restProps, _excluded2);

      var validated = this.verifyResult; // 值校验
      // let errorMsg;
      // if (validated.hasError && !hideDefaultErrorMsg) {
      //     errorMsg = this.getDefaultErrorMsg(validated.errorMsg);
      // }

      var classNames = classnames("sui-component sui-daterange", {
        'has-error': validated.hasError,
        'sui-component-readonly': attrs.readOnly,
        'sui-component-disabled': attrs.disabled
      });
      format = formatString || (props.use12Hours ? 'h:mm:ss a' : 'HH:mm:ss');
      var date = value || defaultValue ? moment(value || defaultValue, format) : undefined;
      return /*#__PURE__*/React.createElement("span", {
        style: componentStyle,
        id: id,
        ref: this.getRefDOM,
        className: classNames
      }, /*#__PURE__*/React.createElement(_TimePicker, _extends({
        id: labelId
      }, props, attrs, {
        onOpenChange: this.openChangeHandler,
        format: format,
        value: date,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onChange: this.changeHandler,
        ref: this.getRefInstance
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return this.doRender();
    }
  }]);

  return SuiTimePicker;
}(React.Component), _class2.defaultProps = {
  inputReadOnly: true,
  placeholder: "请选择时间",
  locale: locale
}, _temp)) || _class;

export default SuiTimePicker;